/**
 * MW STUFFS - Delivery Timeline
 * Calculates ship + delivery dates relative to today using configured day offsets.
 * Format: "5 May" or "5 May–6 May" if range
 */
(function () {
  if (customElements.get('delivery-timeline')) return;

  const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function addDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  }

  function formatDate(date) {
    return `${date.getDate()} ${MONTHS_SHORT[date.getMonth()]}`;
  }

  function formatRange(minDate, maxDate) {
    if (minDate.getTime() === maxDate.getTime()) {
      return formatDate(minDate);
    }
    // Same month: "5 May–6"
    if (minDate.getMonth() === maxDate.getMonth()) {
      return `${minDate.getDate()}–${maxDate.getDate()} ${MONTHS_SHORT[maxDate.getMonth()]}`;
    }
    // Different months: "30 Apr–2 May"
    return `${formatDate(minDate)}–${formatDate(maxDate)}`;
  }

  class DeliveryTimeline extends HTMLElement {
    connectedCallback() {
      const shipMin = parseInt(this.dataset.shipMin, 10) || 2;
      const shipMax = parseInt(this.dataset.shipMax, 10) || 3;
      const deliverMin = parseInt(this.dataset.deliverMin, 10) || 5;
      const deliverMax = parseInt(this.dataset.deliverMax, 10) || 8;

      const today = new Date();
      const shipFrom = addDays(today, shipMin);
      const shipTo = addDays(today, shipMax);
      const deliverFrom = addDays(today, deliverMin);
      const deliverTo = addDays(today, deliverMax);

      const shipsEl = this.querySelector('[data-date-ships]');
      const deliveredEl = this.querySelector('[data-date-delivered]');

      if (shipsEl) shipsEl.textContent = formatRange(shipFrom, shipTo);
      if (deliveredEl) deliveredEl.textContent = formatRange(deliverFrom, deliverTo);
    }
  }

  customElements.define('delivery-timeline', DeliveryTimeline);
})();